import React from "react";
import { DashboardContext } from "./context";
import { SnackbarInternalProps } from "./types";

export const DashboardContextProvider: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  const [snackbarProps, setSnackbarProps] = React.useState<
    SnackbarInternalProps | undefined
  >(undefined);
  const [snackbarPropsOpen, setSnackbarPropsOpen] = React.useState(false);

  const show = React.useCallback(
    (props: SnackbarInternalProps) => {
      setSnackbarProps(props);
      setSnackbarPropsOpen(true);
    },
    [setSnackbarProps, setSnackbarPropsOpen]
  );
  const handleOnClose = React.useCallback(
    () => setSnackbarPropsOpen(false),
    [setSnackbarPropsOpen]
  );

  return (
    <DashboardContext.Provider
      value={{
        snackbarSection: {
          show,
          props: snackbarProps
            ? {
                ...snackbarProps,
                open: snackbarPropsOpen,
                onClose: handleOnClose,
              }
            : undefined,
        },
      }}
    >
      {children}
    </DashboardContext.Provider>
  );
};
